import '.a{display:grid;}.ssr-plugin'
import '.m{gap:1.5rem;}.ssr-plugin'
import { Title } from '@app/components/core/typography/Title'
import Row from '@app/components/layout/Row'
import Column from '@app/components/layout/Column'
import { DashboardPageLayout } from '@app/pages/layout/DashboardPageLayout'
import { i18n } from '@i18n/index'
import { useLanguage } from '@i18n/useLanguage'
import { enrich } from '@i18n/localizeHelper'
import { useUserContext } from '@app/util/hooks/useUserContext'
import { DashboardInfoCard } from '@app/components/blocks/card/DashboardInfoCard'
import { BlogCard } from '@app/components/blocks/card/BlogCard'
import { pages } from '@app/util/links'
import { useQuery } from '@based/sdk/react'
import { useLocation } from 'wouter'
import { styled } from 'inlines'
import startInitiativeImage from '@app/assets/images/consult-experts.png'
import discoverImage from '@app/assets/images/people_looking_for_house.png'
import KnowledgeHubImage from '@app/assets/images/start-initiative.png'
import { BlogListModel } from 'functions/app/blog/list'
import useMediaQuery from '@app/util/useMediaQuery'

const STORIES_COUNT = 3

type BlogItem = Omit<BlogListModel, 'author'>

export const ProfileHome = () => {
  const isMobile = useMediaQuery()
  const [language, _setLanguage] = useLanguage()
  const translations = i18n.languages[language].app.dashboard.home
  const storiesLabel = i18n.languages[language].app.blogPage.tabs.stories
  const { user } = useUserContext()
  const firstName = user?.firstName ?? 'Anon'
  const [, navigate] = useLocation()

  const blogQuery = useQuery('list-blog', { top: STORIES_COUNT })
  const blogPosts: BlogItem[] = blogQuery.data ?? []

  return (
    <DashboardPageLayout gap="0">
      <Title.H3 style={{ marginBottom: '1.5rem' }}>
        {enrich(translations.title, firstName)}
      </Title.H3>

      <Row
        gap="1.5rem"
        style={{
          flexWrap: 'wrap',
          alignItems: 'stretch',
          marginBottom: '2.5rem',
        }}
      >
        <Column style={{ flex: '1 1 18rem', minWidth: '16rem' }}>
          <DashboardInfoCard
            image={KnowledgeHubImage}
            title={translations.KnowledgeHubCardTitle}
            description={translations.KnowledgeHubCardDescription}
            buttonLabel={translations.KnowledgeHub}
            onClick={() => navigate(pages.knowledgeHub)}
          />
        </Column>
        <Column style={{ flex: '1 1 18rem', minWidth: '16rem' }}>
          <DashboardInfoCard
            image={discoverImage}
            title={translations.DiscoverCardTitle}
            description={translations.DiscoverCardDescription}
            buttonLabel={translations.DiscoverMore}
            onClick={() => navigate(pages.initiatives)}
          />
        </Column>
        <Column style={{ flex: '1 1 18rem', minWidth: '16rem' }}>
          <DashboardInfoCard
            image={startInitiativeImage}
            title={translations.StartInitiativeCardTitle}
            description={translations.StartInitiativeCardDescription}
            buttonLabel={translations.StartInitiative}
            onClick={() => navigate(pages.dashboardStartInitiative)}
          />
        </Column>
      </Row>

      {blogPosts.length > 0 && (
        <Column gap="1rem" alignItems="stretch">
          <Title.H5 style={{ margin: 0, whiteSpace: 'pre-line' }}>
            {translations.StoriesTitle}
          </Title.H5>
          <div className="a m"
            style={{
              gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, minmax(0, 1fr))',
            }}
          >
            {blogPosts.map((post) => (
              <BlogCard
                key={post.id}
                image={post.images?.[0]?.src ?? ''}
                meta={storiesLabel}
                title={post.title}
                intro={post.intro}
                orientation="horizontal"
                titleStyle={{ fontSize: '1.15rem' }}
                introStyle={{ fontSize: '0.875rem' }}
                onClick={() => navigate(pages.blog('blog', post.slug))}
              />
            ))}
          </div>
        </Column>
      )}
    </DashboardPageLayout>
  )
}
